import React from 'react'
import './TablePagination.css';
import Pagination from "react-js-pagination";
import { useTranslation } from 'react-i18next';
import { PerPageGroup, PerPageLabel, PerPageSelect, TPContainer } from './TablePagination.styled';
import { FormGroup, FormLabel, FormSelect } from '../../../styles/Common';
import  ListeMenu from '../DensityAndColumns/ListeMenu'
import ShowColumns from '../DensityAndColumns/ShowColumns';
import CloseIcon from '@mui/icons-material/Close';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Axios from '../../../axios-proas';
import {getNotyfObject} from '../../../shared/utility';
import { CTooltip } from '../CTooltip/CTooltip';
function TablePagination(props) {      
    const { t } = useTranslation();
    const notyf = getNotyfObject();
    const config = { headers: { "X-CSRF": "1", }, };
    const { currentPage, pageChange, totalElement, perPage, perPageChange, setDensity, columns, setColumns, lastInvoice, saveConfiguration, title, connectedUserId } = props;
    const pageNumbers = [];
    const pageElement = perPage || 10;
    for (let i = 1; i <= Math.ceil(totalElement / pageElement); i++) {
        pageNumbers.push(i);
    }
  const updateConfiguration=()=> {
      let data = { ClaimType: title, ClaimValue: JSON.stringify(columns) }
    
      Axios.put(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/configurationupdate/' + connectedUserId, data).then((response) => {
       
          notyf.success("La configuration des colonnes a été sauvegardé");
            })
        

    }

  return (
      <TPContainer>
          {
              (perPageChange && lastInvoice===undefined) && (
                <PerPageGroup>
                    <PerPageLabel htmlFor="perPage">{t("global:rows", 'Lignes')}</PerPageLabel>
                    <PerPageSelect 
                        id="perPage" 
                        value={perPage}
                        onChange={(e) => perPageChange(e.target.value)}
                    >
                        {/* <option value="2">2</option> */}
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </PerPageSelect>
                    { setDensity?
                    <ListeMenu setDensity={setDensity}/>:null}
                    {columns?
                          <ShowColumns columns={columns} setColumns={setColumns} /> : null}
                      {saveConfiguration ?
                          <>
                              
                              <SaveAsIcon style={{ color: '#47aaf1' }} onClick={() => updateConfiguration()} />
                              <CTooltip title="Conserver la configuration actuelle">
                                  <PerPageLabel onClick={() => updateConfiguration()} htmlFor="perPage">{"   " + ' Sauvegarde '}</PerPageLabel>
                              </CTooltip>
                         </>
                          : null}
                </PerPageGroup>
              )
          }{
              <nav className="usersMAnag__paginationContainer">
                  <div className="usersMAnag__paginationList">
                      <Pagination
                          activePage={currentPage}
                          itemsCountPerPage={pageElement}
                          totalItemsCount={totalElement}
                          pageRangeDisplayed={5}
                          onChange={(page) => pageChange(page)}
                          innerClass={"usersMAnag__pagination"}
                          itemClass={"usersMAnag__page_item"}
                          linkClass={"usersMAnag__page_link"}
                          activeClass={"usersMAnag__active"}
                          disabledClass={"usersMAnag__disabled"}
                      />
                      <span className="usersMAnag__pagination__total">{totalElement} {t('tableAction:result', { defaultValue: "résultat(s)" })} </span>
                  </div>

              </nav>
          }
       
    </TPContainer>
  )
}

export default TablePagination
